import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/services/api";

// Public /watch page polls the unauthenticated stream endpoint directly, so
// the same polling shape as useLiveStream applies: active streams are
// polled quickly, a session without a stream yet (404) is polled more
// slowly, and terminal states stop polling entirely.
const PUBLIC_STREAM_POLL_INTERVAL_MS = 10_000;
const PUBLIC_STREAM_ABSENT_POLL_INTERVAL_MS = 30_000;

export function usePublicStream(sessionId: string) {
  return useQuery({
    queryKey: ["public-stream", sessionId],
    queryFn: () => apiClient.getSessionStream(sessionId),
    enabled: !!sessionId,
    refetchInterval: (query) => {
      const status = query.state.data?.displayStatus;
      if (!status) return PUBLIC_STREAM_ABSENT_POLL_INTERVAL_MS;
      if (status === "ended" || status === "deleted") return false;
      return PUBLIC_STREAM_POLL_INTERVAL_MS;
    },
    retry: (failureCount, error: unknown) => {
      // Do not retry on 404 (session may not have a stream yet)
      const axiosError = error as { response?: { status?: number } };
      if (axiosError?.response?.status === 404) return false;
      return failureCount < 2;
    },
  });
}
